import { render, staticRenderFns } from "./SignUpPage.vue?vue&type=template&id=7e0be8e8&scoped=true"
import script from "./SignUpPage.vue?vue&type=script&lang=ts"
export * from "./SignUpPage.vue?vue&type=script&lang=ts"
import style0 from "./SignUpPage.vue?vue&type=style&index=0&id=7e0be8e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0be8e8",
  null
  
)

export default component.exports